import React, {useEffect, useState} from 'react';
import {animateScroll as scroll} from "react-scroll";
import arrowUp from "../../../pages/Hint/HintCards/img/arrowUp.svg";
import {HandySvg} from "handy-svg";
import "./StyleButtonUpScroll.css"

const ButtonUpScroll = () => {

    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        if (window.scrollY > 100) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    };

    const scrollToTop = () => {
        scroll.scrollToTop({
            duration: 100,
            smooth: true,
        });
    };

    return (
        <div className="butUpScroll" onClick={scrollToTop}>
            наверх
            <HandySvg src={arrowUp} className="arrowUpHintCard"/>
        </div>
    );
};

export default ButtonUpScroll;